import EnterIcon from "assets/svgs/ic_enter.svg";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { selectTicketTypes } from "app/redux/selector";
import {
  selectTicketCreateLoading,
  selectTicketFormDetail,
} from "../../containers/Tickets/redux/selector";
import { attachClickOutsideListener } from "../Settings/helper";
import useTicketHandlers from "./useTicketHandlers";
import TicketInput from "./TicketInput";
import Fields from "./Fields";
import TicketActions from "./TicketActions";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { TicketGroup } from "../../containers/Tickets/types";

interface Props {
  readonly group: TicketGroup;
  readonly minTableWidth?: number;
}

export default function Index({ group,minTableWidth }: Props) {
  const params = useParams();
  const dispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);

  const form = useSelector(selectTicketFormDetail);
  const ticketTypes = useSelector(selectTicketTypes);
  const loading = useSelector(selectTicketCreateLoading);

  const [selectedIcon, setSelectedIcon] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const onCancel = () => {
    dispatch(ticketGroupsActions.clearCreateTicket());
    dispatch(
      ticketGroupsActions.toggleCreateTicketIntoGroup({
        groupId: "",
        actions: false,
      }),
    );
  };
  const {
    handleChange,
    handleInputKeyDown,
    handleCreateTicket,
    handleInputEscapeKeyDown,
  } = useTicketHandlers({ dispatch, params, group, onCancel });


  
  // Handle ticket type icon
  useEffect(() => {
    const icon = ticketTypes.find((ele) => ele?._id === form?.type);
    if (icon) setSelectedIcon(icon.icon);
  }, [form?.type, ticketTypes]);

  // Outside click cleanup
  React.useEffect(() => {
    const cleanup = attachClickOutsideListener(ref, () => {
      if (isDropdownOpen) {
        setIsDropdownOpen(false);
        return;
      }

      if (!form?.title || form?.title.length === 0) {
        onCancel();
      }
    });

    return cleanup;
  }, [form?.title, isDropdownOpen]);

  
  return (
    <div className="pe-[24px] ps-[62px]">
      <div
        ref={ref}
        className="w-full h-[36px] flex flex-row items-center gap-2 group bg-white mt-[5px] mb-[15px]"
        style={{ minWidth: minTableWidth }}
      >
        <div className="flex flex-row items-center sticky left-[62px] z-20 h-full">
          <div className="absolute -left-[62px] w-[62px] bg-gray-400 h-full" />
          <div className="flex items-center justify-center size-[16px] w-full">
            <div className="flex items-center justify-start flex-0 w-[25vw]">
              <TicketInput
                form={form}
                ticketTypes={ticketTypes}
                selectedIcon={selectedIcon}
                handleChange={handleChange}
                handleInputKeyDown={(e) => {
                  if (form?.title?.length > 0) {
                    handleInputKeyDown(e);
                  } else {
                    handleInputEscapeKeyDown(e);
                  }
                }}
                loading={loading}
              />
            </div>
            <div className="flex items-center flex-0 gap-[10px] shrink-0">
              <Fields
                onOpen={() => setIsDropdownOpen(true)}
                onClose={() => setIsDropdownOpen(false)}
                form={form}
                group={group}
              />
              <TicketActions
                onCancel={onCancel}
                onSave={handleCreateTicket}
                disabled={!form?.title?.length}
                loading={loading}
                EnterIcon={EnterIcon}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
